import React from 'react'

const FormSection = ({ title, subtitle, icon, children }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        {icon && (
          <div className="p-2 bg-gray-100 rounded-lg">
            <div className="text-gray-600">
              {icon}
            </div>
          </div>
        )}
        <div>
          <h4 className="text-lg font-medium text-gray-900">{title}</h4>
          {subtitle && (
            <p className="text-sm text-gray-500">{subtitle}</p>
          )}
        </div>
      </div>
      <div className="pl-0">
        {children}
      </div>
    </div>
  )
}

export default FormSection